module.exports = __webpack_public_path__ + "img/familia.2c3a0755.jpg";